import { useApolloClient } from "@vue/apollo-composable";
import { useAuth } from "@/core/composables/useAuth";
import { useLanguages } from "@/core/composables/useLanguages";
import { USER_ID_LOCAL_STORAGE } from "@/core/constants";
import { TabsType, pageReloadEvent, useBroadcast } from "@/shared/broadcast";

// Extension cache keys - must match useCheckout.ts
const LAST_SHIPPING_EXTENSION_KEY = "checkout_last_shipping_extension";
const LAST_BILLING_EXTENSION_KEY = "checkout_last_billing_extension";

export function useSignMeOut(options: { reloadPage?: boolean } = { reloadPage: true }) {
  const { client } = useApolloClient();
  const broadcast = useBroadcast();
  const { removeLocaleFromUrl, unpinLocale } = useLanguages();

  const { unauthorize } = useAuth();

  async function signMeOut() {
    await unauthorize();

    await client.clearStore();

    unpinLocale();
    removeLocaleFromUrl();

    localStorage.removeItem("currency");
    localStorage.removeItem(USER_ID_LOCAL_STORAGE);
    // Clear checkout extension cache to prevent cross-user data leaks
    localStorage.removeItem(LAST_SHIPPING_EXTENSION_KEY);
    localStorage.removeItem(LAST_BILLING_EXTENSION_KEY);

    if (options.reloadPage) {
      void broadcast.emit(pageReloadEvent, undefined, TabsType.ALL);
    }
  }

  return {
    signMeOut,
  };
}
